/**
 * converts String (date and time) into String with local date/time-format
 * @param {String} dateIn
 * @param {Intl.DateTimeFormatOptions} options
 * @param {String} locale
 * @returns {String}
 */
export const convertDateTime = (dateIn: string, locale: string, options?: Intl.DateTimeFormatOptions): string => {
  if (dateIn) {
    const dateStr = dateIn.split("T")[0];

    const convertedDateStr = dateStr.split("-");
    const year = convertedDateStr[0];
    const month = convertedDateStr[1];
    const day = convertedDateStr[2];

    const date = new Date(year, month - 1, day).toLocaleString(
      locale,
      options
        ? options
        : {
            year: "numeric",
            month: "numeric",
            day: "numeric",
          },
    );

    const timeStr = dateIn.split("T")[1];
    const timeArr = timeStr.split(":");

    return `${date} - ${timeArr[0]}:${timeArr[1]}`;
  }
  return ``;
};
